import { KeyValue } from '@/main/models/common';
import { IInitialReducerData } from '@/main/services/reducerUtils';

export enum ExcludeVariablesTypes {
  GET_EXCLUDE_VARIABLES = '@excludeVariables/GET_EXCLUDE_VARIABLES',
  SAVE_EXCLUDE_VARIABLES = '@excludeVariables/SAVE_EXCLUDE_VARIABLES',
  RESET_REDUCER_EXCLUDE_VARIABLES = '@excludeVariables/RESET_REDUCER_EXCLUDE_VARIABLES'
}

export interface ExcludeVariablesState {
  readonly excludeVariables: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: IInitialReducerData;
  };
}

export interface GetExcludeVariables {
  type: typeof ExcludeVariablesTypes.GET_EXCLUDE_VARIABLES;
  payload: {
    request: string;
    keyReducer: string;
  };
}

export interface SaveExcludeVariables {
  type: typeof ExcludeVariablesTypes.SAVE_EXCLUDE_VARIABLES;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerExcludeVariables {
  type: typeof ExcludeVariablesTypes.RESET_REDUCER_EXCLUDE_VARIABLES;
}

export type ExcludeVariablesActionTypes =
  | GetExcludeVariables
  | SaveExcludeVariables
  | ResetReducerExcludeVariables;
